export const SET_STATE = 'SET_OTU_VISION_STATE'
export const RESET = 'RESET_OTU_VISION_STATE'

export const VIDEO_CONFERENCE_JOINED = 'VIDEO_CONFERENCE_JOINED'
export const PARTICIPANT_USER_ID_KNOWN = 'PARTICIPANT_USER_ID_KNOWN'
export const PARTICIPANT_JOINED = 'PARTICIPANT_JOINED'
export const PARTICIPANT_LEFT = 'PARTICIPANT_LEFT'

export const SET_SCREEN_SHARE = 'SET_SCREEN_SHARE'
export const SET_IGNORE_DEVICE_WARNING = 'SET_IGNORE_DEVICE_WARNING'

export const SET_FILM_STRIP_DISPLAY = 'SET_FILM_STRIP_DISPLAY'

export const SHOW_RECORDING_INSTRUCTIONS = 'SHOW_RECORDING_INSTRUCTIONS'
export const CLOSE_RECORDING_INSTRUCTIONS = 'CLOSE_RECORDING_INSTRUCTIONS'

export const DOMINANT_SPEAKER_CHANGED = 'DOMINANT_SPEAKER_CHANGED'